export const API_PREFIX = '/api/eva/';

const EndpointTemplate = {
  Categories: `${API_PREFIX}:productType/lobby/categories`,
  Category: `${API_PREFIX}:productType/lobby/categories/:categoryId`,
  CategoriesByIds: `${API_PREFIX}lobby/categories/ids`,

  Themes: `${API_PREFIX}:productType/lobby/themes`,
  Theme: `${API_PREFIX}:productType/lobby/themes/:themeId`,

  Providers: `${API_PREFIX}:productType/lobby/providers`,
  Provider: `${API_PREFIX}:productType/lobby/providers/:providerId`,
  ProvidersByIds: `${API_PREFIX}lobby/providers/ids`,

  Games: `${API_PREFIX}:productType/lobby/games`,
  GamesByIds: `${API_PREFIX}:productType/lobby/games/ids`,
  GameRandom: `${API_PREFIX}:productType/lobby/games/random`,
  GameInfo: `${API_PREFIX}:productType/lobby/game/info/:gameId`,
  DemoGame: `${API_PREFIX}:productType/lobby/game/demo/:gameId`,
  RealGame: `${API_PREFIX}:productType/lobby/game/real/:gameId`,

  Favourites: `${API_PREFIX}:productType/lobby/favourites`,
  ToggleFavouriteGame: `${API_PREFIX}:productType/lobby/favourites/:gameId`,
  FavouritesCommon: `${API_PREFIX}lobby/favourites`,

  Jackpots: `${API_PREFIX}:productType/jackpot-system`,
  HallOfFame: `${API_PREFIX}:productType/hall-of-fame`,

  Recents: `${API_PREFIX}:productType/recents`,
  RecentsBulk: `${API_PREFIX}:productType/recents/bulk`,

  // Bonus system
  Bonuses: `${API_PREFIX}:productType/bonus-system`,
  BonusGames: `${API_PREFIX}:productType/lobby/config?availableForBonus=true`,
  BonusCampaign: `${API_PREFIX}:productType/bonus-system/campaigns/:campaignId`,
  BonusHistory: `${API_PREFIX}:productType/bonus-system/history`,
  JoinCampaign: `${API_PREFIX}:productType/bonus-system/:campaignId/join`,
  RejectBonus: `${API_PREFIX}:productType/bonus-system/:campaignId/:bonusId/cancel`,
  UnjoinBonus: `${API_PREFIX}:productType/bonus-system/:bonusId/unjoin`,
  TakeBonus: `${API_PREFIX}:productType/bonus-system/:campaignId/:bonusId/take`,

  BonusCollectingGames: `${API_PREFIX}:productType/bonus-system/games/:campaignId/collecting`,
};

export default EndpointTemplate;
